import store from 'store2';

const EVENT_SERVICE_LOCAL_STORAGE = '_sberlead_event_storage_';

export const getStorage = (): any[] => {
  return store(EVENT_SERVICE_LOCAL_STORAGE) ?? [];
};

export const setStorage = (data: any): any[] => {
  const newData = [...getStorage(), data];
  store(EVENT_SERVICE_LOCAL_STORAGE, newData);

  return newData;
};

export const updateStorage = (data: any[]): any[] => {
  store(EVENT_SERVICE_LOCAL_STORAGE, data);

  return data;
};